// removed by extract-text-webpack-plugin
module.exports = {"extra-large":"1920px","large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile-l":"640px","mobile-s":"320px","hotspots":"_26X3xbJEiTFPMxkgNhtMrb","selfcare":"_2i2osA8jKNraxkUFD-ur1r","fullwidth":"ujsdcdhLmfGRTggi8tn89"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Hotspots/Hotspots.css
// module id = 1461
// module chunks = 0